import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { BellRing, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function WorkshopInterestDialog({ workshop, triggerClassName, triggerLabel = "Register interest" }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", email: "" });
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) { toast.error("Please enter your name and email."); return; }
    setSubmitting(true);
    try {
      await api.post(`/workshops/${workshop.id}/book`, { workshop_id: workshop.id, ...form });
      toast.success("Interest registered — we'll email you as soon as dates are released.");
      setForm({ name: "", email: "" });
      setOpen(false);
    } catch { toast.error("Something went wrong. Please try again."); }
    finally { setSubmitting(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className={triggerClassName} data-testid={`workshop-interest-trigger-${workshop.id}`}>
          <BellRing className="w-4 h-4" /> {triggerLabel}
        </Button>
      </DialogTrigger>
      <DialogContent data-testid="workshop-interest-dialog">
        <DialogHeader><DialogTitle className="font-display">{workshop.title}</DialogTitle></DialogHeader>
        <DialogDescription className="text-sm text-slate-600 -mt-2">
          Register your interest and we'll let you know first when dates are confirmed. No payment required.
        </DialogDescription>
        <form onSubmit={submit} className="space-y-4 mt-2">
          <div>
            <Label htmlFor="wi-name">Full name</Label>
            <Input id="wi-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1.5" data-testid="workshop-interest-name" />
          </div>
          <div>
            <Label htmlFor="wi-email">Email</Label>
            <Input id="wi-email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1.5" data-testid="workshop-interest-email" />
          </div>
          <Button type="submit" disabled={submitting} className="w-full bg-teal-600 hover:bg-teal-700 rounded-full" data-testid="workshop-interest-submit">
            {submitting ? <Loader2 className="w-4 h-4 animate-spin" /> : "Register my interest"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
